/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "e443d5b322837761c3668ce858fda06da40b52cc";
